import { IChannel } from "@Interfaces";

/**
 * Safely build the absolute cover image URL for a channel when both
 * `public_url` and `fid` values are available.
 */
export const getChannelCoverUrl = (
    channel?: Pick<IChannel, "cover"> | null
): string | undefined => {
    const coverImage = channel?.cover?.image;
    if (!coverImage?.public_url || !coverImage?.fid) {
        return undefined;
    }
    return `${coverImage.public_url}/${coverImage.fid}`;
};
